var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D1E0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 31.5H24C22.6044 31.5 21.9067 31.5 21.3389 31.6722C20.0605 32.06 19.06 33.0605 18.6722 34.3389C18.5 34.9067 18.5 35.6044 18.5 37M35.5 37V31M32.5 34H38.5M31 23.5C31 25.9853 28.9853 28 26.5 28C24.0147 28 22 25.9853 22 23.5C22 21.0147 24.0147 19 26.5 19C28.9853 19 31 21.0147 31 23.5Z",
    stroke: "#004EEB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#EFF4FF",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4269cae7a93c74640fdde1085e5bc82c.svg";
export { ForwardRef as ReactComponent };